import styled from '@emotion/styled';
import { IconButton, Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

const Button = styled(MuiButton)<{ isActive: boolean }>`
  height: 45px;
  margin: 6px 0;
  border-radius: 44px;
  box-shadow: 0px 0px 0px 0px rgba(172, 172, 172, 0.25);
  min-width: 145px;
  padding: 12px;
  width: 100%;
  text-transform: none;
  font-family: var(--font-work-sans);
  font-weight: 600;
  font-size: 16px;
  background: ${props => (props.isActive ? '#4c3b51' : '#f8dfcb')};
  display: flex;
  align-items: center;
  line-height: 1.5;
  color: ${props => (props.isActive ? '#ffffff' : '#4c3b51')};
  :hover {
    cursor: pointer;
    background: rgba(35, 23, 39, 0.2);
    box-shadow: none;
  }
`;
type ButtonProps = MuiButtonProps & {
  icon: React.ReactNode;
  children: React.ReactNode;
  isActive: boolean;
};
const TabButton = ({ icon, children, isActive, ...rest }: ButtonProps) => {
  return (
    <Button startIcon={<IconButton>{icon}</IconButton>} isActive={isActive} {...rest}>
      {children}
    </Button>
  );
};
export default TabButton;
